import React, { FC, useState, useEffect } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation } from 'react-query';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
// import { handleCompanyUrl } from 'utils/organizationUtils';
import { useHistory } from 'react-router';
import { useStyles } from './styles';
import { Grid } from '@material-ui/core';
const RegisterCallback: FC = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const {
    userStore: { googleRegister },
    notificationStore: { openNotification },
  } = useStore();
  const [message, setMessage] = useState('');

  // const googleRequest = useMutation(() => googleRegister(location.search, 'user'), {
  //   onSuccess: (data: any) => {
  //     console.log(data?.message);
  //     openNotification(
  //       'success',
  //       'Thank you for signing up. Your account is currently being activated. This process usually takes up to 5 minutes. You’ll receive an email notification once activation is complete.'
  //     );
  //     setTimeout(() => {
  //       history.push('/login');
  //     }, 2000);
  //   },
  //   onError: ({ message }: Error) => {
  //     openNotification('error', message ? message : 'Something went wrong');
  //     setTimeout(() => {
  //       history.push('/login');
  //     }, 2000);
  //   },
  // });

  const googleRequest = useMutation(() => googleRegister(location.search, 'user'), {
    onSuccess: (data: any) => {
      openNotification(
        'success',
        data?.message ||
          'Thank you for signing up. Your account is currently being activated. This process usually takes up to 5 minutes. You’ll receive an email notification once activation is complete.'
      );

      setTimeout(() => {
        history.push('/login');
      }, 2000);
    },

    onError: ({ message }: Error) => {
      openNotification('error', message || 'Something went wrong');
      setMessage(message || 'Something went wrong');

      setTimeout(() => {
        history.push('/login');
      }, 2000);
    },
  });

  useEffect(() => {
    if (location.search) {
      new URLSearchParams(location.search);
      googleRequest.mutate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useAppPreloader(googleRequest.isLoading);
  // return null;
  return (
    <>
      {message && (
        <div className={classes.containers}>
          <div className={classes.alertContainer}>
            <div className={classes.alertboxes}>
              <Grid className={classes.alertmessage}>
                <div className={classes.alertbox}>
                  <div>
                    <div className={classes.alertTitle}>{message}</div>
                  </div>
                </div>
              </Grid>
            </div>
          </div>
        </div>
      )}
    </>
  );
});
export default RegisterCallback;
